import { Component, Input, OnInit } from '@angular/core';
import { eThemeMetronicComponents } from '../../enums/components';

@Component({
	selector: 'hedou-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.less']
})
export class NavbarComponent implements OnInit {

	@Input() isNavbarExpanded: boolean;

	@Input() smallScreen;

	navItemsComponentKey = eThemeMetronicComponents.NavItems;
	constructor() { }

	ngOnInit(): void {
	}

}
